import React, { useContext, useMemo } from 'react';
import useCourseStyles from './styles';
import tagIcon from '../../assets/images/tagIcon.svg';
import { getShortenedSubstring } from '../../utils';
import PageContext from '../../contexts/pageContext';

import NextImageRenderer from '../../components/nextImageRenderer';
import { formatCurrency } from '../../utils/currencyUtils';

function CourseCard({ card, countryCode, currencySymbol, utmParams }) {
  const classes = useCourseStyles();

  const { isEdit } = useContext(PageContext);

  const discount = parseInt(
    ((card?.price - card?.finalPrice) / card?.price) * 100
  ).toFixed(2);

  const defaultCardImg =
    'https://cp-assets-public.s3.ap-south-1.amazonaws.com/cams/cards-icon/default_course.png';

  const price = formatCurrency(countryCode, card?.price, currencySymbol);
  const finalPrice = formatCurrency(
    countryCode,
    card?.finalPrice,
    currencySymbol
  );
  const buyNowText = countryCode === 'KR' ? '수강신청하기' : 'Buy Now';
  const offText = countryCode === 'KR' ? '할인' : 'OFF';

  return (
    <div className={classes.singleCard}>
      <div className={classes.courseCardImg}>
        <NextImageRenderer
          src={card?.imageUrl ? card?.imageUrl : defaultCardImg}
          className={classes.courseCardImgThumbnail}
        />
      </div>
      <div className={classes.courseCardData}>
        <div>
          <div className={classes.courseCardTags}>
            {card?.tag?.text == 'LIVE COURSE' && (
              <div className={classes.courseCardTag}> LIVE COURSE</div>
            )}
            {!!card?.isSamplingEnabled && (
              <div className={classes.courseCardTag}> FREE CONTENT</div>
            )}
            {!!card?.isPhysicalDeliveryEnabled && (
              <div className={classes.courseCardTag}> BOOKS</div>
            )}
          </div>
          <div className={classes.courseCardName}>
            {getShortenedSubstring(card?.name, 50)}
          </div>
          {card.maxCouponDiscount && card.maxCouponDiscount.text && (
            <div className={classes.courseCardDiscount}>
              <img src={tagIcon} alt="" />
              {card.maxCouponDiscount.text}
            </div>
          )}
          {card?.tag?.text == 'LIVE COURSE' ||
          !!card?.isSamplingEnabled ||
          !!card?.isPhysicalDeliveryEnabled ? (
            <></>
          ) : (
            <div style={{ paddingTop: '20px' }}></div>
          )}
        </div>
        <div className={classes.courseCardFooter}>
          <div className={classes.courseCardPriceContainer}>
            <div className={classes.courseCardPrice}>{finalPrice}</div>
            {card?.price !== card?.finalPrice ? (
              <div className={classes.courseCardStrikePrice}>
                <span>{price}</span> {discount > 0 && discount + `% ${offText}`}
              </div>
            ) : null}
          </div>
          <a
            className={classes.coursesAnchorTag}
            href={
              isEdit
                ? null
                : utmParams
                ? card?.shareableLink + `?flyy_utm_referrer=${utmParams}`
                : card?.shareableLink
            }
          >
            <div className={classes.courseCardBuyBtn}>{buyNowText}</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default CourseCard;
